import client from './http';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};
export const getSuppliers = () => client.get('suppliers/', config);
export const createSupplier = supplier => client.post('suppliers/new', supplier, config);



// WEBPACK FOOTER //
// ./src/services/suppliers.js